import { combineReducers } from 'redux';
import userSlicer from './slices/userSlice';
import commonSlicer from './slices/commonSlice';
import sseSlicer from './slices/sseSlice';
import TenantSlicer from './slices/tenantSlice';

const RootReducer = combineReducers({
  users: userSlicer,
  common: commonSlicer,
  sse: sseSlicer,
  tenant: TenantSlicer,
});

export default RootReducer;
